import React from "react";
import "../styles/layout.css";

// Component takes JSON object as prop
export default function DashboardWidget({ data }) {
  const total = (obj) => Object.values(obj).reduce((a, b) => a + b, 0);

  const renderSection = (title, obj, totalLabel) => (
    <div className="dashboard-section">
      <h3 className="section-title">{title}</h3>
      <div className="section-content">
        <div className="device-box">
          {Object.entries(obj).map(([key, value]) => (
            <div key={key} className="device-item">
              <span className="device-value">{value}</span>
            </div>
          ))}
        </div>
        <div className="total-box">
          <p className="total-label">{totalLabel}</p>
          <p className="total-value">{total(obj).toLocaleString()}</p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="dashboard-widget">
      {renderSection("Total Device In stock", data.stock, "Total Devices")}
      {renderSection("Total Device Inward", data.inward, "Total Inwards")}
      {renderSection("Total Device Outward", data.outward, "Total Outward")}
    </div>
  );
}
